import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../redux/store";
import MultiSelectChips from "./MultiSelectChips";
import { DropwdownInitailValueTypes } from "../../hooks/useSearchAndFilter";
import useOutsideClick from "../../hooks/useOutsideClick";
import MultiSelectFilter from "./MultiSelectFilter";
import SearchInput from "./SearchInput";
import DispatchFilter from "./DispatchFilter";
import { useLocation } from "react-router-dom";
import { SALES_REP_ROLE } from "../../utils/salesRepAccess";

interface FilterModalProps {
  isShowFilterModal?: boolean;
  closeOpenfilterModal?: () => void;
  selectStatus?: DropwdownInitailValueTypes;
  setSelectStatus?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes>
  >;
  selectApiType?: DropwdownInitailValueTypes;
  setSelectApiType?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes>
  >;
  selectedRoles?: DropwdownInitailValueTypes[];
  setSelectedRoles?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  rolesDropdownData?: DropwdownInitailValueTypes[];
  setRolesDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  fetchFilteredData?: (
    currentPage?: number,
    status?: DropwdownInitailValueTypes,
    roles?: DropwdownInitailValueTypes[],
    orderStatus?: DropwdownInitailValueTypes[],
    orderType?: DropwdownInitailValueTypes[],
    handlingType?: DropwdownInitailValueTypes[],
    reportType?: DropwdownInitailValueTypes[],
    reportCat?: DropwdownInitailValueTypes[],
    reportDateType?: DropwdownInitailValueTypes[],
    reportSchSelected?: DropwdownInitailValueTypes[],
    paymentStatusSelected?: DropwdownInitailValueTypes[],
    agentType?: DropwdownInitailValueTypes[],
    hubs?: DropwdownInitailValueTypes[],
    services?: DropwdownInitailValueTypes[],
    customerSelectedLevel?: DropwdownInitailValueTypes,
    customerTypeLevel?: DropwdownInitailValueTypes[],
    agentUpdateStartDate?: string,
    agentUpdateEndDate?: string,
    dtsUpdateStartDate?: string,
    dtsUpdateEndDate?: string,
    createdStartDate?: string,
    createdEndDate?: string,
    invoiceFrom?: string,
    invoiceTo?: string,
    dueFrom?: string,
    dueTo?: string,
    orderDateFrom?: string,
    orderDateTo?: string,
    apiType?: DropwdownInitailValueTypes,
    orderNumber?: string,
    consigneeName?: string,
    customerName?: string,
    firstName?: string,
    lastName?: string,
    agentName?: string,
    carrierCode?: string,
    reportTitle?: string,
    createdBy?: string,
    invoiceGroup?: string,
    invoiceEDI?: DropwdownInitailValueTypes,
    invoiceEmail?: DropwdownInitailValueTypes,
    invoiceNumber?: string,
    orderRef?: string,
    admin?: string,
    service?: string,
    vehicleType?: string,
    packageType?: string,
    hubName?: string,
    templateName?: string,
    templateForSelected?: DropwdownInitailValueTypes[],
    billingAccountCode?: string,
    invoiceSettingSelected?: DropwdownInitailValueTypes[],
    city?: string,
    state?: string,
    zipcode?: string,
    address?: string,
    description?: string,
    scac?: string,
    carrier?: string,
    stateOfRegion?: string,
    region?: string,
    serviceName?: string,
    onwardService?: string,
    agentEmail?: string,
    subCustomerName?: string,
    country?: string,
    rateCharge?: string,
    repName?: string,
    repCustomerSelected?: DropwdownInitailValueTypes[],
    commissionTypeSelected?: DropwdownInitailValueTypes[],
    logisticsTypeSelected?: DropwdownInitailValueTypes,
    moduleSelected?: DropwdownInitailValueTypes[],
  ) => void;
  onFiltersApplied?: () => void;
  isStatusHide?: boolean;
  isCustomerTypeHide?: boolean;
  isAllCustomerTypeHide?: boolean;
  isRoleHide?: boolean;
  isOrderStatusHide?: boolean;
  isAgentTypeHide?: boolean;
  isOrderTypeHide?: boolean;
  showHandlingType?: boolean;
  isHubHide?: boolean;
  isAgentUpdateDate?: boolean;
  isCreatedOn?: boolean;
  isCreatedBy?: boolean;
  isReportScheduling?: boolean;
  showAdmin?: boolean;
  showService?: boolean;
  showVehicleType?: boolean;
  showPackageType?: boolean;
  showHubName?: boolean;
  showRegion?: boolean;
  showServiceName?: boolean;
  showLocationName?: boolean;
  showonwardService?: boolean;
  isReportType?: boolean;
  isReportCat?: boolean;
  isDTSUpdateDate?: boolean;
  isServiceHide?: boolean;
  roleApiUrl?: string;
  orderStatusApiUrl?: string;
  orderTypeApiUrl?: string;
  fetchDropdownApiUrl?: string;
  agentTypeApiUrl?: string;
  hubApiUrl?: string;
  serviceApiUrl?: string;
  orderStatusSelected?: DropwdownInitailValueTypes[];
  setOrderStatusSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  orderStatusDropdownData?: DropwdownInitailValueTypes[];
  setOrderStatusDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  customerLevelDropdownData?: DropwdownInitailValueTypes[];
  setCustomerLevelDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  customerTypeLevel?: DropwdownInitailValueTypes[];
  setCustomerTypeLevel?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  filterData?: any;
  orderTypeSelected?: DropwdownInitailValueTypes[];
  setOrderTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  handlingUnitSelected?: DropwdownInitailValueTypes[];
  setHandlingUnitSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  orderTypeDropdownData?: DropwdownInitailValueTypes[];
  setOrderTypeDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  handlingUnitDropDownData?: DropwdownInitailValueTypes[];
  setHandlingUnitDropDownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  agentTypeSelected?: DropwdownInitailValueTypes[];
  setAgentTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  agentTypeDropdownData?: DropwdownInitailValueTypes[];
  setAgentTypeDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  hubSelected?: DropwdownInitailValueTypes[];
  setHubSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  hubDropdownData?: DropwdownInitailValueTypes[];
  setHubDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  serviceSelected?: DropwdownInitailValueTypes[];
  setServiceSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  serviceDropdownData?: DropwdownInitailValueTypes[];
  setServiceDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  customerSelectedLevel?: DropwdownInitailValueTypes;
  setCustomerSelectedLevel?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes>
  >;
  agentUpdateStartDate?: string;
  setAgentUpdateStartDate?: (date: string) => void;
  agentUpdateEndDate?: string;
  setAgentUpdateEndDate?: (date: string) => void;
  dtsUpdateStartDate?: string;
  setDtsStartDate?: (date: string) => void;
  dtsUpdateEndDate?: string;
  setDtsEndDate?: (date: string) => void;
  invoiceFrom?: string;
  setInvoiceFrom?: (date: string) => void;
  invoiceTo?: string;
  setInvoiceTo?: (date: string) => void;
  dueFrom?: string;
  setDueFrom?: (date: string) => void;
  dueTo?: string;
  setDueTo?: (date: string) => void;
  orderDateFrom?: string;
  setOrderDateFrom?: (date: string) => void;
  orderDateTo?: string;
  setOrderDateTo?: (date: string) => void;
  filterApplied?: boolean;
  setFilterApplied?: React.Dispatch<React.SetStateAction<boolean>>;
  reportSchSelected?: DropwdownInitailValueTypes[];
  setReportSchSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  reportSchDropdownData?: DropwdownInitailValueTypes[];
  setReportSchDropDownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  reportTypeSelected?: DropwdownInitailValueTypes[];
  setReportTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  reportTypeDropdownData?: DropwdownInitailValueTypes[];
  setReportTypeDropDownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  reportCatSelected?: DropwdownInitailValueTypes[];
  setReportCatSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  reportCatDropdownData?: DropwdownInitailValueTypes[];
  setReportCatDropDownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  isReportDateType?: boolean;
  reportDateTypeSelected?: DropwdownInitailValueTypes[];
  setReportDateTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  reportDateTypeDropdownData?: DropwdownInitailValueTypes[];
  setReportDateTypeDropDownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  paymentStatusSelected?: DropwdownInitailValueTypes[];
  setPaymentStatusSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  paymentStatusDropdownData?: DropwdownInitailValueTypes[];
  setPaymentStatusDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  invoiceSettingSelected?: DropwdownInitailValueTypes[];
  setInvoiceSettingSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  invoiceSettingDropdownData?: DropwdownInitailValueTypes[];
  setInvoiceSettingDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  createdStartDate?: string;
  setCreatedStartDate?: (date: string) => void;
  createdEndDate?: string;
  setCreatedEndDate?: (date: string) => void;
  consigneeName?: string;
  setConsigneeName?: React.Dispatch<React.SetStateAction<string>>;
  customerName?: string;
  setCustomerName?: React.Dispatch<React.SetStateAction<string>>;
  orderNumber?: string;
  setOrderNumber?: React.Dispatch<React.SetStateAction<string>>;
  firstName?: string;
  setFirstName?: React.Dispatch<React.SetStateAction<string>>;
  lastName?: string;
  setLastName?: React.Dispatch<React.SetStateAction<string>>;
  agentName?: string;
  setAgentName?: React.Dispatch<React.SetStateAction<string>>;
  agentEmail?: string;
  setAgentEmail?: React.Dispatch<React.SetStateAction<string>>;
  showAgentEmail?: boolean;
  customStatusOptions?: { value: string; label: string }[];
  carrierCode?: string;
  setCarrierCode?: React.Dispatch<React.SetStateAction<string>>;
  table?: string;
  reportTitle?: string;
  setReportTitle?: React.Dispatch<React.SetStateAction<string>>;
  createdBy?: string;
  setCreatedBy?: React.Dispatch<React.SetStateAction<string>>;
  invoiceGroup?: string;
  setInvoiceGroup?: React.Dispatch<React.SetStateAction<string>>;
  invoiceEDI?: DropwdownInitailValueTypes;
  setInvoiceEDI?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes>
  >;
  invoiceEmail?: DropwdownInitailValueTypes;
  setInvoiceEmail?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes>
  >;
  invoiceNumber?: string;
  setInvoiceNumber?: React.Dispatch<React.SetStateAction<string>>;
  orderRef?: string;
  setOrderRef?: React.Dispatch<React.SetStateAction<string>>;
  admin?: string;
  setAdmin?: React.Dispatch<React.SetStateAction<string>>;
  service?: string;
  setService?: React.Dispatch<React.SetStateAction<string>>;
  vehicleType?: string;
  setVehicleType?: React.Dispatch<React.SetStateAction<string>>;
  packageType?: string;
  setPackageType?: React.Dispatch<React.SetStateAction<string>>;
  hubName?: string;
  setHubName?: React.Dispatch<React.SetStateAction<string>>;
  region?: string;
  setRegion?: React.Dispatch<React.SetStateAction<string>>;
  stateOfRegion?: string;
  setStateOfRegion?: React.Dispatch<React.SetStateAction<string>>;
  serviceName?: string;
  setServiceName?: React.Dispatch<React.SetStateAction<string>>;
  onwardService?: string,
  setOnwardService?: React.Dispatch<React.SetStateAction<string>>;
  showSubCustomerName?: boolean;
  subCustomerName?: string;
  setSubCustomerName?: React.Dispatch<React.SetStateAction<string>>;
  showOrderNumber?: boolean;
  showConsigneeName?: boolean;
  showCustomerName?: boolean;
  isDirectCustomer?: boolean;
  showFirstName?: boolean;
  showLastName?: boolean;
  showAgentName?: boolean;
  showCarrierCode?: boolean;
  showReportTitle?: boolean;
  showCreatedBy?: boolean;
  showInvoiceGroup?: boolean;
  showInvoiceEDI?: boolean;
  showInvoiceEmail?: boolean;
  showInvoiceNumber?: boolean;
  showInvoiceDate?: boolean;
  showDueDate?: boolean;
  showPaymentStatus?: boolean;
  showOrderRef?: boolean;
  showServiceType?: boolean;
  showOrderDate?: boolean;
  showTempaleSearch?: boolean;
  templateName?: string;
  setTemplateName?: React.Dispatch<React.SetStateAction<string>>;
  isShowTemplateFor?: boolean;
  templateForApiUrl?: string;
  templateForDropdownData?: DropwdownInitailValueTypes[];
  setTemplateForDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  templateForSelected?: DropwdownInitailValueTypes[];
  setTemplateForSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  showBillingAccountCode?: boolean;
  billingAccountCode?: string;
  setBillingAccountCode?: React.Dispatch<React.SetStateAction<string>>;
  customOrderStatusDropdownData?: any[];
  showInvoiceSetting?: boolean;
  invoiceSetting?: string;
  setInvoiceSetting?: React.Dispatch<React.SetStateAction<string>>;
  showCity?: boolean;
  showState?: boolean;
  showZipCode?: boolean;
  showCountry?: boolean;
  showAddress?: boolean;
  showDescription?: boolean;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
  setCity?: React.Dispatch<React.SetStateAction<string>>;
  setState?: React.Dispatch<React.SetStateAction<string>>;
  setZipCode?: React.Dispatch<React.SetStateAction<string>>;
  setCountry?: React.Dispatch<React.SetStateAction<string>>;
  countryOptions?: { label: string; value: string }[];
  showStateDropdown?: boolean;
  stateOptions?: { label: string; value: string }[];
  address?: string;
  setAddress?: React.Dispatch<React.SetStateAction<string>>;
  description?: string;
  setDescription?: React.Dispatch<React.SetStateAction<string>>;
  showScac?: boolean;
  scac?: string;
  setScac?: React.Dispatch<React.SetStateAction<string>>;
  showCarrier?: boolean;
  carrier?: string;
  setCarrier?: React.Dispatch<React.SetStateAction<string>>;
  showRateCharge?: boolean;
  rateCharge?: string;
  setRateCharge?: React.Dispatch<React.SetStateAction<string>>;
  // My Rep List filters
  showRepName?: boolean;
  repName?: string;
  setRepName?: React.Dispatch<React.SetStateAction<string>>;
  showRepEmail?: boolean;
  isRepCustomer?: boolean;
  repCustomerSelected?: DropwdownInitailValueTypes[];
  setRepCustomerSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  repCustomerDropdownData?: DropwdownInitailValueTypes[];
  setRepCustomerDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  isCommissionType?: boolean;
  commissionTypeSelected?: DropwdownInitailValueTypes[];
  setCommissionTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  // Services list: single-select Service Type (delivery / pickup).
  // Distinct from `showServiceType`, which is the order-page service-level multiselect.
  showLogisticsType?: boolean;
  logisticsTypeSelected?: DropwdownInitailValueTypes;
  setLogisticsTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes>
  >;
  commissionTypeDropdownData?: DropwdownInitailValueTypes[];
  setCommissionTypeDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  // Audit Log "Module" multiselect — options supplied via filterData.auditListModule.
  isModule?: boolean;
  moduleSelected?: DropwdownInitailValueTypes[];
  setModuleSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  moduleDropdownData?: DropwdownInitailValueTypes[];
  setModuleDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  // Communications ticket listing (table "ticketQueue") multiselects — options supplied via
  // filterData.ticketRegion / ticketPriority / ticketStatus / ticketGroup / ticketUserType.
  // The listing keeps these selections itself (not in useSearchAndFilter), so they are not
  // fetchFilteredData args: Apply / Clear only tell it which page to fetch.
  isTicketRegion?: boolean;
  ticketRegionSelected?: DropwdownInitailValueTypes[];
  setTicketRegionSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  ticketRegionDropdownData?: DropwdownInitailValueTypes[];
  setTicketRegionDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  isTicketPriority?: boolean;
  ticketPrioritySelected?: DropwdownInitailValueTypes[];
  setTicketPrioritySelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  ticketPriorityDropdownData?: DropwdownInitailValueTypes[];
  setTicketPriorityDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  isTicketStatus?: boolean;
  ticketStatusSelected?: DropwdownInitailValueTypes[];
  setTicketStatusSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  ticketStatusDropdownData?: DropwdownInitailValueTypes[];
  setTicketStatusDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  isTicketGroup?: boolean;
  ticketGroupSelected?: DropwdownInitailValueTypes[];
  setTicketGroupSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  ticketGroupDropdownData?: DropwdownInitailValueTypes[];
  setTicketGroupDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  isTicketUserType?: boolean;
  ticketUserTypeSelected?: DropwdownInitailValueTypes[];
  setTicketUserTypeSelected?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  ticketUserTypeDropdownData?: DropwdownInitailValueTypes[];
  setTicketUserTypeDropdownData?: React.Dispatch<
    React.SetStateAction<DropwdownInitailValueTypes[]>
  >;
  clearFiltersFromStorage?: () => void;
}

interface apiResponse {
  orderStatus?: {};
  orderType?: {};
  serviceLevel?: {};
}

/**
 * FilterModal component to handle filtering data based on various dropdowns.
 * It allows users to filter based on status, roles, order types, hubs, and service levels.
 *
 * @param isShowFilterModal - Boolean flag to control modal visibility
 * @param closeOpenfilterModal - Function to close the modal
 * @param selectStatus - Current selected status
 * @param setSelectStatus - Setter function for the selected status
 * @param selectedRoles - Current selected roles
 * @param setSelectedRoles - Setter function for selected roles
 * @param rolesDropdownData - Data for roles dropdown
 * @param setRolesDropdownData - Setter function for roles dropdown data
 * @param fetchFilteredData - Function to fetch filtered data based on selected filters
 * @param isStatusHide - Flag to hide the status dropdown
 * @param isCustomerTypeHide - Flag to hide the customer type dropdown
 * @param isRoleHide - Flag to hide the roles dropdown
 * @param isOrderStatusHide - Flag to hide the order status dropdown
 * @param isOrderTypeHide - Flag to hide the order type dropdown
 * @param isAgentTypeHide - Flag to hide the order type dropdown
 * @param isHubHide - Flag to hide the hub dropdown
 * @param isServiceHide - Flag to hide the service level dropdown
 * @param roleApiUrl - API URL for roles dropdown data
 * @param orderStatusApiUrl - API URL for order status dropdown data
 * @param orderTypeApiUrl - API URL for order type dropdown data
 * @param fetchDropdownApiUrl - API URL for order page dropdown data
 * @param agentTypeApiUrl - API URL for order type dropdown data
 * @param hubApiUrl - API URL for hub dropdown data
 * @param serviceApiUrl - API URL for service level dropdown data
 * @param orderStatusSelected - Current selected order statuses
 * @param setOrderStatusSelected - Setter function for selected order statuses
 * @param orderStatusDropdownData - Data for order statuses dropdown
 * @param setOrderStatusDropdownData - Setter function for order status dropdown data
 * @param orderTypeSelected - Current selected order types
 * @param setOrderTypeSelected - Setter function for selected order types
 * @param filterData - All Dropdowns data for the page
 * @param orderTypeDropdownData - Data for order type dropdown
 * @param setOrderTypeDropdownData - Setter function for order type dropdown data
 * @param agentTypeSelected - Current selected order types
 * @param setAgentTypeSelected - Setter function for selected order types
 * @param agentTypeDropdownData - Data for order type dropdown
 * @param setAgentTypeDropdownData - Setter function for order type dropdown data
 * @param hubSelected - Current selected hubs
 * @param setHubSelected - Setter function for selected hubs
 * @param hubDropdownData - Data for hub dropdown
 * @param setHubDropdownData - Setter function for hub dropdown data
 * @param serviceSelected - Current selected services
 * @param setServiceSelected - Setter function for selected services
 * @param serviceDropdownData - Data for service level dropdown
 * @param setServiceDropdownData - Setter function for service dropdown data
 * @param selectedUnitType - Current selected unit type
 * @param isUnitType - Flag to hide the unit type dropdown
 * @param unitTypeApiUrl - API URL for unit type dropdown data
 * @param unitTypeDropdownData - Data for unit Type dropdown
 * @param setUnitTypeDropdownData - Setter function for unit type dropdown data
 * @param setSelectedUnitType - Setter function for selected unit type
 */
const FilterSideMenu: React.FC<FilterModalProps> = ({
  isShowFilterModal,
  closeOpenfilterModal,
  selectStatus,
  setSelectStatus,
  selectApiType,
  setSelectApiType,
  selectedRoles,
  setSelectedRoles,
  rolesDropdownData,
  setRolesDropdownData,
  fetchFilteredData,
  isRoleHide,
  isStatusHide,
  isAllCustomerTypeHide,
  isCustomerTypeHide,
  isOrderStatusHide,
  isOrderTypeHide,
  showHandlingType,
  isAgentTypeHide,
  isHubHide,
  isAgentUpdateDate,
  isCreatedOn,
  isCreatedBy,
  isReportScheduling,
  showAdmin,
  showService,
  showVehicleType,
  showPackageType,
  showHubName,
  showRegion,
  showServiceName,
  showLocationName,
  showonwardService,
  isReportType,
  isReportCat,
  isReportDateType,
  isDTSUpdateDate,
  isServiceHide,
  onFiltersApplied,
  roleApiUrl,
  orderStatusApiUrl,
  orderTypeApiUrl,
  fetchDropdownApiUrl,
  agentTypeApiUrl,
  hubApiUrl,
  serviceApiUrl,
  orderStatusSelected,
  filterData,
  setOrderStatusSelected,
  orderStatusDropdownData,
  setOrderStatusDropdownData,
  orderTypeSelected,
  setOrderTypeSelected,
  handlingUnitSelected,
  setHandlingUnitSelected,
  customerTypeLevel,
  setCustomerTypeLevel,
  orderTypeDropdownData,
  setOrderTypeDropdownData,
  handlingUnitDropDownData,
  setHandlingUnitDropDownData,
  agentTypeSelected,
  setAgentTypeSelected,
  agentTypeDropdownData,
  setAgentTypeDropdownData,
  hubSelected,
  setHubSelected,
  hubDropdownData,
  setHubDropdownData,
  serviceSelected,
  setServiceSelected,
  serviceDropdownData,
  setServiceDropdownData,
  customerSelectedLevel,
  setCustomerSelectedLevel,
  customerLevelDropdownData,
  setCustomerLevelDropdownData,
  agentUpdateStartDate,
  setAgentUpdateStartDate,
  agentUpdateEndDate,
  setAgentUpdateEndDate,
  dtsUpdateStartDate,
  setDtsStartDate,
  dtsUpdateEndDate,
  setDtsEndDate,
  invoiceFrom,
  setInvoiceFrom,
  invoiceTo,
  setInvoiceTo,
  dueFrom,
  setDueFrom,
  dueTo,
  setDueTo,
  orderDateFrom,
  setOrderDateFrom,
  orderDateTo,
  setOrderDateTo,
  filterApplied,
  setFilterApplied,
  reportSchSelected,
  setReportSchSelected,
  reportSchDropdownData,
  setReportSchDropDownData,
  paymentStatusSelected,
  setPaymentStatusSelected,
  paymentStatusDropdownData,
  setPaymentStatusDropdownData,
  reportTypeSelected,
  setReportTypeSelected,
  reportTypeDropdownData,
  setReportTypeDropDownData,
  reportCatSelected,
  setReportCatSelected,
  reportCatDropdownData,
  setReportCatDropDownData,
  reportDateTypeSelected,
  setReportDateTypeSelected,
  reportDateTypeDropdownData,
  setReportDateTypeDropDownData,
  createdStartDate,
  setCreatedStartDate,
  createdEndDate,
  setCreatedEndDate,
  consigneeName,
  setConsigneeName,
  customerName,
  setCustomerName,
  orderNumber,
  setOrderNumber,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  agentName,
  setAgentName,
  agentEmail,
  setAgentEmail,
  showAgentEmail,
  customStatusOptions,
  carrierCode,
  setCarrierCode,
  reportTitle,
  setReportTitle,
  createdBy,
  setCreatedBy,
  invoiceGroup,
  setInvoiceGroup,
  invoiceEDI,
  setInvoiceEDI,
  invoiceEmail,
  setInvoiceEmail,
  invoiceNumber,
  setInvoiceNumber,
  orderRef,
  setOrderRef,
  admin,
  setAdmin,
  service,
  setService,
  vehicleType,
  setVehicleType,
  packageType,
  setPackageType,
  hubName,
  setHubName,
  region,
  setRegion,
  setStateOfRegion,
  stateOfRegion,
  serviceName,
  setServiceName,
  onwardService,
  setOnwardService,
  showSubCustomerName = false,
  subCustomerName,
  setSubCustomerName,
  showConsigneeName,
  showOrderNumber,
  showCustomerName,
  isDirectCustomer = false,
  showFirstName,
  showLastName,
  showAgentName,
  showCarrierCode,
  showReportTitle,
  showCreatedBy,
  showInvoiceGroup,
  showInvoiceEDI,
  showInvoiceEmail,
  showInvoiceNumber,
  showInvoiceDate,
  showDueDate,
  showPaymentStatus,
  showOrderRef,
  showServiceType,
  showOrderDate,
  table,
  showTempaleSearch = false,
  templateName,
  setTemplateName,
  isShowTemplateFor,
  templateForApiUrl,
  templateForDropdownData,
  setTemplateForDropdownData,
  templateForSelected,
  setTemplateForSelected,
  showBillingAccountCode = false,
  billingAccountCode,
  setBillingAccountCode,
  customOrderStatusDropdownData,
  showInvoiceSetting,
  invoiceSettingSelected,
  setInvoiceSettingSelected,
  invoiceSettingDropdownData,
  setInvoiceSettingDropdownData,
  showCity,
  showState,
  showZipCode,
  showCountry,
  showAddress,
  showDescription,
  city,
  state,
  zipcode,
  country,
  setCity,
  setState,
  setZipCode,
  setCountry,
  countryOptions,
  showStateDropdown,
  stateOptions,
  address,
  setAddress,
  description,
  setDescription,
  showScac,
  scac,
  setScac,
  showCarrier,
  carrier,
  setCarrier,
  showRateCharge,
  rateCharge,
  setRateCharge,
  showRepName,
  repName,
  setRepName,
  showRepEmail,
  isRepCustomer,
  repCustomerSelected,
  setRepCustomerSelected,
  repCustomerDropdownData,
  setRepCustomerDropdownData,
  isCommissionType,
  commissionTypeSelected,
  setCommissionTypeSelected,
  commissionTypeDropdownData,
  setCommissionTypeDropdownData,
  showLogisticsType,
  logisticsTypeSelected,
  setLogisticsTypeSelected,
  isModule,
  moduleSelected,
  setModuleSelected,
  moduleDropdownData,
  setModuleDropdownData,
  isTicketRegion,
  ticketRegionSelected,
  setTicketRegionSelected,
  ticketRegionDropdownData,
  setTicketRegionDropdownData,
  isTicketPriority,
  ticketPrioritySelected,
  setTicketPrioritySelected,
  ticketPriorityDropdownData,
  setTicketPriorityDropdownData,
  isTicketStatus,
  ticketStatusSelected,
  setTicketStatusSelected,
  ticketStatusDropdownData,
  setTicketStatusDropdownData,
  isTicketGroup,
  ticketGroupSelected,
  setTicketGroupSelected,
  ticketGroupDropdownData,
  setTicketGroupDropdownData,
  isTicketUserType,
  ticketUserTypeSelected,
  setTicketUserTypeSelected,
  ticketUserTypeDropdownData,
  setTicketUserTypeDropdownData,
  clearFiltersFromStorage,
}) => {
  const { currentPage } = useSelector((state: RootState) => state.pagination);
  const { userRole } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  /**
   * Helper function to safely invoke optional functions if they exist.
   *
   * @param func - Optional function to invoke
   */
  const safeInvoke = (func?: () => void) => func && func();
  /**
   * Memoized function to check if at least one filter is selected.
   *
   * @returns {boolean} - True if at least one filter is selected, false otherwise.
   */
  const isAnyFilterSelected = useMemo(() => {
    if (table === "userList") {
      return (
        selectStatus?.id !== "" ||
        firstName?.trim() != "" ||
        lastName?.trim() != "" ||
        (selectedRoles && selectedRoles.length > 0)
      );
    }
    if (table === "agentList") {
      return (
        selectStatus?.id !== "" ||
        agentName?.trim() != "" ||
        carrierCode?.trim() != "" ||
        (agentTypeSelected && agentTypeSelected.length > 0)
      );
    }
    if (table === "masterAgentList") {
      return (
        agentName?.trim() != "" ||
        (agentTypeSelected && agentTypeSelected.length > 0)
      );
    }
    if (table === "agentRequestList") {
      return (
        selectStatus?.id !== "" ||
        agentName?.trim() !== "" ||
        agentEmail?.trim() !== "" ||
        customerName?.trim() !== "" ||
        (agentTypeSelected && agentTypeSelected.length > 0)
      );
    }
    if (table === "agentApi") {
      return agentName?.trim() != "" || selectStatus?.id !== "";
    }
    if (table === "myRepList") {
      return (
        repName?.trim() !== "" ||
        agentEmail?.trim() !== "" ||
        customerName?.trim() !== "" ||
        (commissionTypeSelected && commissionTypeSelected.length > 0)
      );
    }
    if (table === "service") {
      return (
        service?.trim() != "" ||
        selectStatus?.id !== "" ||
        !!logisticsTypeSelected?.id
      );
    }
    if (table === "packageType") {
      return packageType?.trim() != "" || selectStatus?.id !== "";
    }
    if (table === "vehicleType") {
      return vehicleType?.trim() != "" || selectStatus?.id !== "";
    }
    if (table === "dispatchBoard") {
      return (
        orderNumber?.trim() != "" ||
        orderRef?.trim() != "" ||
        customerName?.trim() != "" ||
        hubName?.trim() != "" ||
        (orderStatusSelected && orderStatusSelected.length > 0) ||
        (serviceSelected && serviceSelected.length > 0) ||
        (orderTypeSelected && orderTypeSelected.length > 0) ||
        (agentUpdateStartDate !== "" && agentUpdateEndDate !== "") ||
        (dtsUpdateStartDate !== "" && dtsUpdateEndDate !== "")
      );
    }
    if (table === "billedOrder") {
      return (
        orderNumber?.trim() != "" ||
        customerName?.trim() != "" ||
        (orderTypeSelected && orderTypeSelected.length > 0) ||
        (serviceSelected && serviceSelected.length > 0)
      );
    }
    if (table === "customerUser") {
      return (
        selectStatus?.id !== "" ||
        firstName?.trim() != "" ||
        lastName?.trim() != "" ||
        admin?.trim() != "" ||
        (selectedRoles && selectedRoles.length > 0)
      );
    }
    if (table === "invoiceGroup") {
      return invoiceGroup?.trim() != "" || invoiceEDI?.id || invoiceEmail?.id;
    }
    if (table === "orderInvoice") {
      return (
        invoiceGroup?.trim() != "" ||
        invoiceNumber?.trim() != "" ||
        (invoiceFrom !== "" && invoiceTo !== "") ||
        (dueFrom !== "" && dueTo !== "") ||
        (paymentStatusSelected && paymentStatusSelected.length > 0) ||
        (invoiceSettingSelected && invoiceSettingSelected.length > 0)
      );
    }
    if (table === "finalizeOrder") {
      return (
        // invoiceGroup?.trim() != "" ||
        customerName?.trim() != "" ||
        orderRef?.trim() != "" ||
        orderNumber?.trim() != "" ||
        (orderTypeSelected && orderTypeSelected.length > 0) ||
        (serviceSelected && serviceSelected.length > 0) ||
        (orderDateFrom !== "" && orderDateTo !== "")
      );
    }
    if (table === "customer") {
      return (
        selectStatus?.id !== "" ||
        customerName?.trim() != "" ||
        customerSelectedLevel?.id
      );
    }
    if (table === "savedReport") {
      return (
        reportTitle?.trim() != "" ||
        customerName?.trim() != "" ||
        (customerTypeLevel && customerTypeLevel.length > 0) ||
        createdBy?.trim() != "" ||
        (reportSchSelected && reportSchSelected.length > 0) ||
        (reportTypeSelected && reportTypeSelected.length > 0) ||
        (reportCatSelected && reportCatSelected.length > 0) ||
        (reportDateTypeSelected && reportDateTypeSelected.length > 0) ||
        (createdStartDate !== "" && createdEndDate !== "")
      );
    }
    if (table === "agentRate") {
      return (
        customerName?.trim() !== "" ||
        hubName?.trim() !== "" ||
        agentName?.trim() !== ""
      );
    }
    if (table === "locationList") {
      return hubName?.trim() !== "";
    }
    if (table === "RegionListingTable") {
      return (
        region?.trim() !== "" ||
        stateOfRegion?.trim() !== ""
      )
    }
    if (table === "OrderStatusListingTable") {
      return (
        serviceName?.trim() !== "" ||
        onwardService?.trim() !== ""
      )
    }
    if (table === "FscLocationListingTable") {
      return serviceName?.trim() !== "";
    }
    if (table === "masterZipCodeListingTable") {
      return (
        zipcode?.trim() !== "" ||
        city?.trim() !== "" ||
        state?.trim() !== "" ||
        country?.trim() !== ""
      );
    }
    if (table === "onwardServiceListing") {
      return (
        onwardService?.trim() !== "" ||
        service?.trim() !== ""
      )
    }
    if (table === "emailTemplate") {
      return (
        templateName?.trim() != "" ||
        selectStatus?.id !== "" ||
        (templateForSelected && templateForSelected.length > 0)
      );
    } else if (table === "addressBook") {
      return (
        city?.trim() != "" ||
        state?.trim() !== "" ||
        zipcode?.trim() ||
        customerName?.trim() !== "" ||
        address?.trim() !== ""
      );
    } else if (table === "customerItem") {
      return (
        customerName?.trim() !== "" ||
        description?.trim() !== "" ||
        (handlingUnitSelected && handlingUnitSelected.length > 0)
      );
    } else if (table === "scac") {
      return scac?.trim() != "" || carrier?.trim() !== "";
    } else if (table === "customerAdditionalCharges") {
      return (
        selectStatus?.id !== "" ||
        rateCharge?.trim() !== "" ||
        hubName?.trim() !== "" ||
        agentName?.trim() !== ""
      );
    } else if (table === "agentAdditionalCharges") {
      return (
        selectStatus?.id !== "" ||
        rateCharge?.trim() !== "" ||
        hubName?.trim() !== "" ||
        customerName?.trim() !== ""
      );
    } else if (table === "customerTechFee") {
      // Decision D7 (Tech Fee): Agent Name, Hub Name and Status only.
      return (
        Boolean(selectStatus?.id) ||
        Boolean(agentName?.trim()) ||
        Boolean(hubName?.trim())
      );
    } else if (table === "auditLogListingTable") {
      return (
        orderNumber?.trim() !== "" ||
        (moduleSelected && moduleSelected.length > 0)
      );
    } else if (table === "ticketQueue") {
      return (
        (ticketRegionSelected && ticketRegionSelected.length > 0) ||
        (ticketPrioritySelected && ticketPrioritySelected.length > 0) ||
        (ticketStatusSelected && ticketStatusSelected.length > 0) ||
        (ticketGroupSelected && ticketGroupSelected.length > 0) ||
        (ticketUserTypeSelected && ticketUserTypeSelected.length > 0)
      );
    } else {
      return (
        selectStatus?.id ||
        customerSelectedLevel?.id ||
        orderNumber?.trim() != "" ||
        customerName?.trim() != "" ||
        consigneeName?.trim() != "" ||
        billingAccountCode?.trim() != "" ||
        orderRef?.trim() != "" ||
        (selectedRoles && selectedRoles.length > 0) ||
        (orderStatusSelected && orderStatusSelected.length > 0) ||
        (orderTypeSelected && orderTypeSelected.length > 0) ||
        (customerTypeLevel && customerTypeLevel.length > 0) ||
        (agentTypeSelected && agentTypeSelected.length > 0) ||
        (hubSelected && hubSelected.length > 0) ||
        (serviceSelected && serviceSelected.length > 0)
      );
    }
  }, [
    selectStatus?.id,
    customerSelectedLevel?.id,
    selectedRoles,
    orderStatusSelected,
    orderTypeSelected,
    handlingUnitSelected,
    customerTypeLevel,
    agentTypeSelected,
    hubSelected,
    serviceSelected,
    agentUpdateStartDate,
    agentUpdateEndDate,
    dtsUpdateStartDate,
    dtsUpdateEndDate,
    orderNumber,
    firstName,
    lastName,
    agentName,
    agentEmail,
    carrierCode,
    consigneeName,
    customerName,
    subCustomerName,
    invoiceGroup,
    invoiceEDI,
    invoiceEmail,
    invoiceNumber,
    orderRef,
    admin,
    service,
    vehicleType,
    packageType,
    hubName,
    region,
    stateOfRegion,
    serviceName,
    onwardService,
    invoiceFrom,
    invoiceTo,
    dueFrom,
    dueTo,
    orderDateFrom,
    orderDateTo,
    reportTitle,
    createdBy,
    reportSchSelected,
    reportTypeSelected,
    reportCatSelected,
    reportDateTypeSelected,
    createdStartDate,
    createdEndDate,
    paymentStatusSelected,
    templateName,
    templateForSelected,
    billingAccountCode,
    invoiceSettingSelected,
    city,
    state,
    zipcode,
    country,
    address,
    description,
    scac,
    carrier,
    rateCharge,
    repName,
    repCustomerSelected,
    commissionTypeSelected,
    logisticsTypeSelected?.id,
    moduleSelected,
    ticketRegionSelected,
    ticketPrioritySelected,
    ticketStatusSelected,
    ticketGroupSelected,
    ticketUserTypeSelected,
  ]);

  /**
   * Handles changes to the status select field.
   * Updates the selectStatus state with the selected option.
   *
   * @param e - The change event from the select dropdown
   */
  const handleSelectFieldChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    fieldName: string
  ) => {
    const { value } = e.target;
    const selectedName =
      e.target.options[e.target.selectedIndex].getAttribute("data-name");
    if (fieldName === "selectedStatus") {
      setSelectStatus &&
        setSelectStatus?.({ name: selectedName ?? "", id: value });
    }
    // if (fieldName === "selectedInvoiceSetting") {
    //   setInvoiceSetting && setInvoiceSetting?.(value);
    // }
    if (fieldName === "customerSelectedLevel") {
      setCustomerSelectedLevel &&
        setCustomerSelectedLevel?.({ name: selectedName ?? "", id: value });
    }
    if (fieldName === "logisticsType") {
      setLogisticsTypeSelected &&
        setLogisticsTypeSelected?.({ name: selectedName ?? "", id: value });
    }
    if (fieldName === "invoiceEDI") {
      setInvoiceEDI && setInvoiceEDI?.({ name: selectedName ?? "", id: value });
    }
    if (fieldName === "invoiceEmail") {
      setInvoiceEmail &&
        setInvoiceEmail?.({ name: selectedName ?? "", id: value });
    }
  };

  /**
   * Handles the Apply button click event.
   * Calls the fetchFilteredData function only if at least one filter is selected.
   */
  const handleApplyFilter = () => {
    if (isAnyFilterSelected) {
      onFiltersApplied?.();
      setFilterApplied && setFilterApplied(true);
      fetchFilteredData &&
        fetchFilteredData(
          1,
          selectStatus,
          selectedRoles,
          orderStatusSelected,
          orderTypeSelected,
          handlingUnitSelected,
          reportTypeSelected,
          reportCatSelected,
          reportDateTypeSelected,
          reportSchSelected,
          paymentStatusSelected,
          agentTypeSelected,
          hubSelected,
          serviceSelected,
          customerSelectedLevel,
          customerTypeLevel,
          agentUpdateStartDate,
          agentUpdateEndDate,
          dtsUpdateStartDate,
          dtsUpdateEndDate,
          createdStartDate,
          createdEndDate,
          invoiceFrom,
          invoiceTo,
          dueFrom,
          dueTo,
          orderDateFrom,
          orderDateTo,
          selectApiType,
          orderNumber,
          consigneeName,
          customerName,
          firstName,
          lastName,
          agentName,
          carrierCode,
          reportTitle,
          createdBy,
          invoiceGroup,
          invoiceEDI,
          invoiceEmail,
          invoiceNumber,
          orderRef,
          admin,
          service,
          vehicleType,
          packageType,
          hubName,
          templateName,
          templateForSelected,
          billingAccountCode,
          invoiceSettingSelected,
          city,
          state,
          zipcode,
          address,
          description,
          scac,
          carrier,
          region,
          stateOfRegion,
          onwardService,
          serviceName,
          agentEmail,
          subCustomerName,
          country,
          rateCharge,
          repName,
          repCustomerSelected,
          commissionTypeSelected,
          logisticsTypeSelected,
          moduleSelected,
        );
      safeInvoke(closeOpenfilterModal);
    } else if (filterApplied) {
      handleClearFilter();
    }
  };

  const handleFilterKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleApplyFilter();
    }
  };

  /**
   * Handles the Clear button click event.
   * Resets the selected filters (status and roles) to their initial values and
   * calls fetchFilteredData to fetch the unfiltered data.
   */
  const handleClearFilter = () => {
    const clearedStatus: DropwdownInitailValueTypes = { name: "", id: "" };
    const clearedApiType: DropwdownInitailValueTypes = { name: "", id: "" };
    const clearedCustomerSelectedLevel: DropwdownInitailValueTypes = {
      name: "",
      id: "",
    };
    const clearedInvoiceEDI: DropwdownInitailValueTypes = {
      name: "",
      id: "",
    };
    const clearedInvoiceEmail: DropwdownInitailValueTypes = {
      name: "",
      id: "",
    };
    const clearedRoles: DropwdownInitailValueTypes[] = [];
    const clearedOrderStatus: DropwdownInitailValueTypes[] = [];
    const clearedOrderType: DropwdownInitailValueTypes[] = [];
    const clearedHandlingUnit: DropwdownInitailValueTypes[] = [];
    const clearedReportType: DropwdownInitailValueTypes[] = [];
    const clearedReportCat: DropwdownInitailValueTypes[] = [];
    const clearedReportDateType: DropwdownInitailValueTypes[] = [];
    const clearedReportSch: DropwdownInitailValueTypes[] = [];
    const clearedPaymentStatus: DropwdownInitailValueTypes[] = [];
    const clearedInvoiceSetting: DropwdownInitailValueTypes[] = [];
    const clearedAgentType: DropwdownInitailValueTypes[] = [];
    const clearedHub: DropwdownInitailValueTypes[] = [];
    const clearedService: DropwdownInitailValueTypes[] = [];
    const clearedCustomerLevel: DropwdownInitailValueTypes[] = [];
    const clearedTemplateFor: DropwdownInitailValueTypes[] = [];
    const clearedCreatedStartDate: string = "";
    const clearedCreatedEndDate: string = "";
    const clearedagentUpdateStartDate: string = "";
    const clearedagentUpdateEndDate: string = "";
    const cleareddtsUpdateStartDate: string = "";
    const cleareddtsUpdateEndDate: string = "";
    const clearedInvoiceFrom: string = "";
    const clearedInvoiceTo: string = "";
    const clearedDueFrom: string = "";
    const clearedDueTo: string = "";
    const clearedOrderDateFrom: string = "";
    const clearedOrderDateTo: string = "";
    const clearedTemplateName: string = "";
    // Update the state to reflect cleared filters
    setSelectStatus && setSelectStatus(clearedStatus);
    setCustomerSelectedLevel &&
      setCustomerSelectedLevel(clearedCustomerSelectedLevel);
    setSelectedRoles && setSelectedRoles(clearedRoles);
    setOrderStatusSelected && setOrderStatusSelected(clearedOrderStatus);
    setOrderTypeSelected && setOrderTypeSelected(clearedOrderType);
    setHandlingUnitSelected && setHandlingUnitSelected(clearedHandlingUnit);
    setReportTypeSelected && setReportTypeSelected(clearedReportType);
    setReportCatSelected && setReportCatSelected(clearedReportCat);
    setReportDateTypeSelected && setReportDateTypeSelected(clearedReportDateType);
    setReportSchSelected && setReportSchSelected(clearedReportSch);
    setPaymentStatusSelected && setPaymentStatusSelected(clearedPaymentStatus);
    setInvoiceSettingSelected &&
      setInvoiceSettingSelected(clearedInvoiceSetting);
    setAgentTypeSelected && setAgentTypeSelected(clearedAgentType);
    setTemplateForSelected && setTemplateForSelected(clearedTemplateFor);
    setHubSelected && setHubSelected(clearedHub);
    setServiceSelected && setServiceSelected(clearedService);
    setCustomerTypeLevel && setCustomerTypeLevel(clearedCustomerLevel);
    setCreatedStartDate && setCreatedStartDate(clearedCreatedStartDate);
    setCreatedEndDate && setCreatedEndDate(clearedCreatedEndDate);
    setAgentUpdateStartDate &&
      setAgentUpdateStartDate(clearedagentUpdateStartDate);
    setAgentUpdateEndDate && setAgentUpdateEndDate(clearedagentUpdateEndDate);
    setDtsStartDate && setDtsStartDate(cleareddtsUpdateStartDate);
    setDtsEndDate && setDtsEndDate(cleareddtsUpdateEndDate);
    setInvoiceFrom && setInvoiceFrom(clearedInvoiceFrom);
    setInvoiceTo && setInvoiceTo(clearedInvoiceTo);
    setDueFrom && setDueFrom(clearedDueFrom);
    setDueTo && setDueTo(clearedDueTo);
    setOrderDateFrom && setOrderDateFrom(clearedOrderDateFrom);
    setOrderDateTo && setOrderDateTo(clearedOrderDateTo);
    setTemplateName && setTemplateName(clearedTemplateName);
    setConsigneeName && setConsigneeName("");
    setCustomerName && setCustomerName("");
    setOrderNumber && setOrderNumber("");
    setFirstName && setFirstName("");
    setLastName && setLastName("");
    setAgentName && setAgentName("");
    setAgentEmail && setAgentEmail("");
    setCarrierCode && setCarrierCode("");
    setReportTitle && setReportTitle("");
    setCreatedBy && setCreatedBy("");
    setInvoiceGroup && setInvoiceGroup("");
    setBillingAccountCode && setBillingAccountCode("");
    setInvoiceEDI && setInvoiceEDI(clearedInvoiceEDI);
    setInvoiceEmail && setInvoiceEmail(clearedInvoiceEmail);
    setInvoiceNumber && setInvoiceNumber("");
    setOrderRef && setOrderRef("");
    setAdmin && setAdmin("");
    setService && setService("");
    setVehicleType && setVehicleType("");
    setPackageType && setPackageType("");
    setHubName && setHubName("");
    setCity && setCity("");
    setState && setState("");
    setZipCode && setZipCode("");
    setAddress && setAddress("");
    setDescription && setDescription("");
    setScac && setScac("");
    setCarrier && setCarrier("");
    setRegion && setRegion("");
    setStateOfRegion && setStateOfRegion("");
    setServiceName && setServiceName("");
    setOnwardService && setOnwardService("");
    setSubCustomerName && setSubCustomerName("");
    setCountry && setCountry("");
    setRateCharge && setRateCharge("");
    setRepName && setRepName("");
    setRepCustomerSelected && setRepCustomerSelected([]);
    setCommissionTypeSelected && setCommissionTypeSelected([]);
    setLogisticsTypeSelected && setLogisticsTypeSelected({ name: "", id: "" });
    setModuleSelected && setModuleSelected([]);
    setTicketRegionSelected && setTicketRegionSelected([]);
    setTicketPrioritySelected && setTicketPrioritySelected([]);
    setTicketStatusSelected && setTicketStatusSelected([]);
    setTicketGroupSelected && setTicketGroupSelected([]);
    setTicketUserTypeSelected && setTicketUserTypeSelected([]);
    // Fetch unfiltered data
    fetchFilteredData &&
      fetchFilteredData?.(
        currentPage,
        clearedStatus,
        clearedRoles,
        clearedOrderStatus,
        clearedOrderType,
        clearedHandlingUnit,
        clearedReportType,
        clearedReportCat,
        clearedReportDateType,
        clearedReportSch,
        clearedPaymentStatus,
        clearedAgentType,
        clearedHub,
        clearedService,
        clearedCustomerSelectedLevel,
        clearedCustomerLevel,
        clearedagentUpdateStartDate,
        clearedagentUpdateEndDate,
        cleareddtsUpdateStartDate,
        cleareddtsUpdateEndDate,
        clearedCreatedStartDate,
        clearedCreatedEndDate,
        clearedInvoiceFrom,
        clearedInvoiceTo,
        clearedDueFrom,
        clearedDueTo,
        clearedOrderDateFrom,
        clearedOrderDateTo
      );
    setFilterApplied && setFilterApplied(false);
    safeInvoke(clearFiltersFromStorage);
    // Close the modal
    safeInvoke(closeOpenfilterModal);
  };

  /**
   * Render a MultiSelectChips component for filtering options.
   *
   * @param labelTitle - The label for the dropdown
   * @param apiUrl - The API URL to fetch dropdown data
   * @param dropdownData - The current dropdown data
   * @param selectedData - The currently selected items
   * @param setDropdownData - Setter function for the dropdown data
   * @param setSelectedData - Setter function for the selected items
   */
  const renderMultiSelectChips = (
    labelTitle: string,
    apiUrl: string,
    key: string,
    dropdownData: DropwdownInitailValueTypes[] | undefined,
    selectedData: DropwdownInitailValueTypes[] | undefined,
    setDropdownData:
      | React.Dispatch<React.SetStateAction<DropwdownInitailValueTypes[]>>
      | undefined,
    setSelectedData:
      | React.Dispatch<React.SetStateAction<DropwdownInitailValueTypes[]>>
      | undefined
  ) => (
    <MultiSelectFilter
      apiData={filterData ? filterData[key] : {}}
      dropdownData={dropdownData ?? []}
      selectedData={selectedData ?? []}
      setDropdownData={setDropdownData ?? (() => { })}
      setSelectedData={setSelectedData ?? (() => { })}
      searchPlaceholder="Search"
      labelTitle={labelTitle}
      keyBindName="name"
      onApply={handleApplyFilter}
    />
  );

  // Ref to handle clicks outside the dropdown to close it
  // const dropdownRef = useOutsideClick<HTMLDivElement>(() => {
  //   closeOpenfilterModal && closeOpenfilterModal();
  // });

  // Early return if the modal should not be shown
  if (!isShowFilterModal) return null;

  // const handleKeywordChange = (
  //   setKeyword: React.Dispatch<React.SetStateAction<string>> | undefined,
  //   keyword: string
  // ) => {
  //   setKeyword && setKeyword(keyword);
  // };

  const handleKeywordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const name = e.target.name;
    if (name === "orderNumber") {
      setOrderNumber && setOrderNumber(value.trimStart());
    }
    if (name === "consigneeName") {
      setConsigneeName && setConsigneeName(value.trimStart());
    }
    if (name === "customerName") {
      setCustomerName && setCustomerName(value.trimStart());
    }
    if (name === "firstName") {
      setFirstName && setFirstName(value.trimStart());
    }
    if (name === "lastName") {
      setLastName && setLastName(value.trimStart());
    }
    if (name === "agentName") {
      setAgentName && setAgentName(value.trimStart());
    }
    if (name === "agentEmail") {
      setAgentEmail && setAgentEmail(value.trimStart());
    }
    if (name === "repName") {
      setRepName && setRepName(value.trimStart());
    }
    if (name === "carrierCode") {
      setCarrierCode && setCarrierCode(value.trimStart());
    }
    if (name === "invoiceGroup") {
      setInvoiceGroup && setInvoiceGroup(value.trimStart());
    }
    if (name === "invoiceNumber") {
      setInvoiceNumber && setInvoiceNumber(value.trimStart());
    }
    if (name === "orderRef") {
      setOrderRef && setOrderRef(value.trimStart());
    }
    if (name === "admin") {
      setAdmin && setAdmin(value.trimStart());
    }
    if (name === "service") {
      setService && setService(value.trimStart());
    }
    if (name === "packageType") {
      setPackageType && setPackageType(value.trimStart());
    }
    if (name === "hubName") {
      setHubName && setHubName(value.trimStart());
    }
    if (name === "region") {
      setRegion && setRegion(value.trimStart());
    }
    if (name === "stateOfRegion") {
      setStateOfRegion && setStateOfRegion(value.trimStart());
    }
    if (name === "serviceName") {
      setServiceName && setServiceName(value.trimStart());
    }
    if (name === "onwardService") {
      setOnwardService && setOnwardService(value.trimStart());
    }
    if (name === "subCustomerName") {
      setSubCustomerName && setSubCustomerName(value.trimStart());
    }
    if (name === "vehicleType") {
      setVehicleType && setVehicleType(value.trimStart());
    }
    // if (name === "invoiceEDI"){
    //   setInvoiceEDI && setInvoiceEDI(value.trimStart());
    // }
    // if (name === "invoiceEmail"){
    //   setInvoiceEmail && setInvoiceEmail(value.trimStart());
    // }
    if (name === "reportTitle") {
      setReportTitle && setReportTitle(value.trimStart());
    }
    if (name === "createdBy") {
      setCreatedBy && setCreatedBy(value.trimStart());
    }
    if (name === "templateName") {
      setTemplateName && setTemplateName(value.trimStart());
    }
    if (name === "billingAccountCode") {
      setBillingAccountCode && setBillingAccountCode(value.trimStart());
    }
    if (name === "city") {
      setCity && setCity(value.trimStart());
    }
    if (name === "state") {
      setState && setState(value.trimStart());
    }
    if (name === "zipcode") {
      setZipCode && setZipCode(value.trimStart());
    }
    if (name === "country") {
      setCountry && setCountry(value.trimStart());
    }
    if (name === "address") {
      setAddress && setAddress(value.trimStart());
    }
    if (name === "description") {
      setDescription && setDescription(value.trimStart());
    }
    if (name === "Scsc") {
      setScac && setScac(value.trimStart());
    }
    if (name === "carrier") {
      setCarrier && setCarrier(value.trimStart());
    }
    if (name === "rateCharge") {
      setRateCharge && setRateCharge(value.trimStart());
    }
  };
  return (
    <>
      <div
        className={`filter ${isShowFilterModal && "filter--open"} `}
      // ref={dropdownRef}
      >
        <div className="filter__dropdown">
          <div className="filter__dropdown__detail">
            <div className="filter__dropdown__body">
              {showFirstName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search First Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="firstName"
                          value={firstName || ""}
                          placeholder="Search by First Name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showLastName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Last Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="lastName"
                          value={lastName || ""}
                          placeholder="Search by Last Name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showReportTitle && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Report Title
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="reportTitle"
                          value={reportTitle || ""}
                          placeholder="Search by Report Title"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showInvoiceGroup && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Invoice Group
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="invoiceGroup"
                          value={invoiceGroup || ""}
                          placeholder="Search by Invoice Group"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showInvoiceEDI && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="selectedStatus"
                        className="form__label form__label--medium"
                      >
                        Select Invoice EDI
                      </label>
                      <select
                        id="invoiceEDI"
                        className="form__select form__select--sm"
                        value={invoiceEDI?.id}
                        onChange={(e) => {
                          handleSelectFieldChange(e, "invoiceEDI");
                        }}
                        name="invoiceEDI"
                        onKeyDown={handleFilterKeyDown}
                      >
                        <option value="" data-name="">
                          -Select-
                        </option>
                        <option value="1" data-name="Active">
                          Active
                        </option>
                        <option value="0" data-name="Deactivate">
                          Inactive
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {showInvoiceEmail && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="selectedStatus"
                        className="form__label form__label--medium"
                      >
                        Select Invoice Email
                      </label>
                      <select
                        id="invoiceEmail"
                        className="form__select form__select--sm"
                        value={invoiceEmail?.id}
                        onChange={(e) => {
                          handleSelectFieldChange(e, "invoiceEmail");
                        }}
                        name="invoiceEmail"
                        onKeyDown={handleFilterKeyDown}
                      >
                        <option value="" data-name="">
                          -Select-
                        </option>
                        <option value="1" data-name="Active">
                          Active
                        </option>
                        <option value="0" data-name="Deactivate">
                          Inactive
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {showInvoiceNumber && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Invoice Number
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="invoiceNumber"
                          value={invoiceNumber || ""}
                          placeholder="Search by Invoice Number"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {isModule &&
                renderMultiSelectChips(
                  "Select Module",
                  "",
                  "auditListModule",
                  moduleDropdownData,
                  moduleSelected,
                  setModuleDropdownData,
                  setModuleSelected
                )}
              {showOrderNumber && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Order Number
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="orderNumber"
                          value={orderNumber || ""}
                          placeholder="Search by Order No"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showOrderRef && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Reference
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="orderRef"
                          value={orderRef || ""}
                          placeholder="Search by Order Reference"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showRateCharge && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="rateCharge"
                        className="form__label form__label--medium"
                      >
                        Search Rate Charge
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="rateCharge"
                          value={rateCharge || ""}
                          placeholder="Search by Rate Charge"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showRepName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="repName"
                        className="form__label form__label--medium"
                      >
                        Search Rep Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="repName"
                          value={repName || ""}
                          placeholder="search by rep name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showRepEmail && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="agentEmail"
                        className="form__label form__label--medium"
                      >
                        Search Email Address
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="agentEmail"
                          value={agentEmail || ""}
                          placeholder="search by email address"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isRepCustomer &&
                renderMultiSelectChips(
                  "Customer",
                  "",
                  "repCustomer",
                  repCustomerDropdownData,
                  repCustomerSelected,
                  setRepCustomerDropdownData,
                  setRepCustomerSelected
                )}
              {showAgentName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Agent Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="agentName"
                          value={agentName || ""}
                          placeholder="Search by Agent Name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showAgentEmail && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="agentEmail"
                        className="form__label form__label--medium"
                      >
                        Search Agent Email
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="agentEmail"
                          value={agentEmail || ""}
                          placeholder="Search by Agent Email"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showCarrierCode && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Carrier Code
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="carrierCode"
                          value={carrierCode || ""}
                          placeholder="Search by Carrier code"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showConsigneeName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Consignee Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="consigneeName"
                          value={consigneeName || ""}
                          placeholder="Search by Consignee Name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showCustomerName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        {location.pathname === "/agent-rates" ||
                          location.pathname.includes("/agent-list") ||
                          location.pathname.includes("/customer-address-book") ||
                          location.pathname.includes("/customer-items") ||
                          (["/all-orders", "/active-order", "/delivered-order", "/invoiced-order", "/finalized-order", "/cancelled-order", "/dispatch-board-list", "/finalized-orders", "/finalized-orders"].includes(location.pathname) && isDirectCustomer)
                          ? "Search Customer Name / Sub Customer Name"
                          : "Search Customer Name"}
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="customerName"
                          value={customerName || ""}
                          placeholder={
                            location.pathname === "/agent-rates" ||
                              location.pathname.includes("/agent-list") ||
                              location.pathname.includes("/customer-address-book") ||
                              (["/all-orders", "/active-order", "/delivered-order", "/invoiced-order", "/finalized-order", "/cancelled-order", "/dispatch-board-list", "/finalized-orders", "/finalized-orders"].includes(location.pathname) &&  isDirectCustomer)
                              ? "Search Customer Name / Sub Customer Name"
                              : "Search Customer Name"
                          }
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isCommissionType &&
                renderMultiSelectChips(
                  "Commission Type",
                  "",
                  "commissionType",
                  commissionTypeDropdownData,
                  commissionTypeSelected,
                  setCommissionTypeDropdownData,
                  setCommissionTypeSelected
                )}
              {showSubCustomerName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="subCustomerName"
                        className="form__label form__label--medium"
                      >
                        Search Sub-Customer Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="subCustomerName"
                          value={subCustomerName || ""}
                          placeholder="Search Sub-Customer Name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showTempaleSearch && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Template Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="templateName"
                          value={templateName || ""}
                          placeholder="Search by Template Name"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showBillingAccountCode && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Billing Account Code
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="billingAccountCode"
                          value={billingAccountCode || ""}
                          placeholder="Search by Billing Account Code"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* {!isAllCustomerTypeHide &&
                renderMultiSelectChips(
                  "Select Customer Type",
                  "",
                  "customerLevel",
                  customerLevelDropdownData,
                  customerTypeLevel,
                  setCustomerLevelDropdownData,
                  setCustomerTypeLevel
                )} */}
              {isCustomerTypeHide && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Select Customer Type
                      </label>
                      <select
                        id="customerSelectedLevel"
                        className="form__select form__select--sm"
                        value={customerSelectedLevel?.id}
                        onChange={(e) => {
                          handleSelectFieldChange(e, "customerSelectedLevel");
                        }}
                        onKeyDown={handleFilterKeyDown}
                        name="customerSelectedLevel"
                      >
                        <option value="" data-name="">
                          -Select-
                        </option>
                        {userRole === SALES_REP_ROLE && (
                          <option value="direct" data-name="Direct Customer">
                            Direct Customer
                          </option>
                        )}
                        <option value="Customer" data-name="Customer">
                          Parent Customer
                        </option>
                        <option value="Associate" data-name="Associate">
                          Sub Customer
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {!isRoleHide &&
                renderMultiSelectChips(
                  "Select Role",
                  roleApiUrl ?? "",
                  "role",
                  rolesDropdownData,
                  selectedRoles,
                  setRolesDropdownData,
                  setSelectedRoles
                )}
              {/* {!isOrderStatusHide &&
                renderMultiSelectChips(
                  "Select Order Status",
                  orderStatusApiUrl ?? "",
                  "orderStatus",
                  customOrderStatusDropdownData ?? orderStatusDropdownData,
                  orderStatusSelected,
                  setOrderStatusDropdownData,
                  setOrderStatusSelected
                )} */}
              {!isOrderStatusHide &&
                (table === "dispatchBoard" ? (
                  <DispatchFilter
                    apiData={customOrderStatusDropdownData}
                    dropdownData={customOrderStatusDropdownData ?? []}
                    selectedData={orderStatusSelected ?? []}
                    setDropdownData={setOrderStatusDropdownData ?? (() => { })}
                    setSelectedData={setOrderStatusSelected ?? (() => { })}
                    searchPlaceholder="Search"
                    labelTitle="Select Order Status"
                    keyBindName="name"
                    onApply={handleApplyFilter}
                  />
                ) : (
                  renderMultiSelectChips(
                    "Select Order Status",
                    orderStatusApiUrl ?? "",
                    "orderStatus",
                    orderStatusDropdownData,
                    orderStatusSelected,
                    setOrderStatusDropdownData,
                    setOrderStatusSelected
                  )
                ))}
              {showHandlingType &&
                renderMultiSelectChips(
                  "Select Handling Unit Type",
                  orderTypeApiUrl ?? "",
                  "handlingType",
                  handlingUnitDropDownData,
                  handlingUnitSelected,
                  setHandlingUnitDropDownData,
                  setHandlingUnitSelected
                )}
              {!isOrderTypeHide &&
                renderMultiSelectChips(
                  "Select Order Type",
                  orderTypeApiUrl ?? "",
                  "orderType",
                  orderTypeDropdownData,
                  orderTypeSelected,
                  setOrderTypeDropdownData,
                  setOrderTypeSelected
                )}
              {!isAgentTypeHide &&
                renderMultiSelectChips(
                  "Select Agent Type",
                  agentTypeApiUrl ?? "",
                  "agentType",
                  agentTypeDropdownData,
                  agentTypeSelected,
                  setAgentTypeDropdownData,
                  setAgentTypeSelected
                )}
              {showHubName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        {table === "locationList" ? "Search Location Name" : "Search Hub Name"}
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="hubName"
                          value={hubName || ""}
                          placeholder={
                            table === "locationList"
                              ? "Search by Location Name"
                              : "Search by Hub Name"
                          }
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showRegion && (
                <>
                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__Field">
                        <label
                          htmlFor="region"
                          className="form__label form__label--medium"
                        >
                          {table === "RegionListingTable" ? "Search Region" : "Search Here"}
                        </label>
                        <div className="formCol">
                          <SearchInput
                            type="text"
                            name="region"
                            value={region || ""}
                            placeholder={"Search by Region Name"}
                            onChange={handleKeywordChange}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__Field">
                        <label
                          htmlFor="region"
                          className="form__label form__label--medium"
                        >
                          {table === "RegionListingTable" ? "Search State" : "Search Here"}
                        </label>
                        <div className="formCol">
                          <SearchInput
                            type="text"
                            name="stateOfRegion"
                            value={stateOfRegion || ""}
                            placeholder={"Search by State Name"}
                            onChange={handleKeywordChange}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {showServiceName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="serviceName"
                        className="form__label form__label--medium"
                      >
                        Search Order Status Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="serviceName"
                          value={serviceName || ""}
                          placeholder={"Search by Order Status Name"}
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showLocationName && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="locationName"
                        className="form__label form__label--medium"
                      >
                        Search Location Name
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="serviceName"
                          value={serviceName || ""}
                          placeholder={"Search by Location Name"}
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!isHubHide &&
                renderMultiSelectChips(
                  "Select Hub Name",
                  hubApiUrl ?? "",
                  "agentHub",
                  hubDropdownData,
                  hubSelected,
                  setHubDropdownData,
                  setHubSelected
                )}
              {!isServiceHide &&
                renderMultiSelectChips(
                  "Select Service Level",
                  serviceApiUrl ?? "",
                  "serviceLevel",
                  serviceDropdownData,
                  serviceSelected,
                  setServiceDropdownData,
                  setServiceSelected
                )}
              {isShowTemplateFor &&
                renderMultiSelectChips(
                  "Select Template For",
                  templateForApiUrl ?? "",
                  "templateFor",
                  templateForDropdownData,
                  templateForSelected,
                  setTemplateForDropdownData,
                  setTemplateForSelected
                )}
              {isAgentUpdateDate && (
                <div>
                  <label className="form__label form__label--medium">
                    Select Agent Update Date Range
                  </label>
                  <div className="formCol">
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">From</label>
                          <input
                            type="date"
                            id="AgentDateFrom"
                            name="AgentDateFrom"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            max={agentUpdateEndDate || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setAgentUpdateStartDate) {
                                setAgentUpdateStartDate(e.target.value);
                              }
                            }}
                            value={agentUpdateStartDate}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">To</label>
                          <input
                            type="date"
                            id="AgentDateTo"
                            name="AgentDateTo"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            min={agentUpdateStartDate || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setAgentUpdateEndDate) {
                                setAgentUpdateEndDate(e.target.value);
                              }
                            }}
                            value={agentUpdateEndDate}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showInvoiceDate && (
                <div>
                  <label className="form__label form__label--medium">
                    Select Invoice Date Range
                  </label>
                  <div className="formCol">
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">From</label>
                          <input
                            type="date"
                            id="invoiceFrom"
                            name="invoiceFrom"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            max={invoiceTo || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setInvoiceFrom) {
                                setInvoiceFrom(e.target.value);
                              }
                            }}
                            value={invoiceFrom}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">To</label>
                          <input
                            type="date"
                            id="invoiceTo"
                            name="invoiceTo"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            min={invoiceFrom || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setInvoiceTo) {
                                setInvoiceTo(e.target.value);
                              }
                            }}
                            value={invoiceTo}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showDueDate && (
                <div>
                  <label className="form__label form__label--medium">
                    Select Due Date Range
                  </label>
                  <div className="formCol">
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">From</label>
                          <input
                            type="date"
                            id="dueFrom"
                            name="dueFrom"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            max={dueTo || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setDueFrom) {
                                setDueFrom(e.target.value);
                              }
                            }}
                            value={dueFrom}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">To</label>
                          <input
                            type="date"
                            id="dueTo"
                            name="dueTo"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            min={dueFrom || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setDueTo) {
                                setDueTo(e.target.value);
                              }
                            }}
                            value={dueTo}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isCreatedBy &&
                renderMultiSelectChips(
                  "Select Created By",
                  orderStatusApiUrl ?? "",
                  "orderStatus",
                  orderStatusDropdownData,
                  orderStatusSelected,
                  setOrderStatusDropdownData,
                  setOrderStatusSelected
                )}
              {showCreatedBy && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Created By
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="createdBy"
                          value={createdBy || ""}
                          placeholder="Search by Created By"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showAdmin && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Admin
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="admin"
                          value={admin || ""}
                          placeholder="Search by Admin"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showService && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Service
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="service"
                          value={service || ""}
                          placeholder="Search by Service"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showLogisticsType && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="logisticsType"
                        className="form__label form__label--medium"
                      >
                        Select Service Type
                      </label>
                      <select
                        id="logisticsType"
                        className="form__select form__select--sm"
                        value={logisticsTypeSelected?.id ?? ""}
                        onChange={(e) => {
                          handleSelectFieldChange(e, "logisticsType");
                        }}
                        onKeyDown={handleFilterKeyDown}
                        name="logisticsType"
                      >
                        <option value="" data-name="">
                          -Select-
                        </option>
                        <option value="delivery" data-name="Delivery">
                          Delivery
                        </option>
                        <option value="pickup" data-name="Pickup">
                          Pickup
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {showonwardService && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="onwardService"
                        className="form__label form__label--medium"
                      >
                        {location.pathname.includes("/system-configuration/order-status")
                          ? "Search by Onward Order Status Name"
                          : "Search Onward Service Name"}
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="onwardService"
                          value={onwardService || ""}
                          placeholder={
                            location.pathname.includes("/system-configuration/order-status")
                              ? "Search by Onward Order Status Name"
                              : "Search by Onward Service Name"
                          }
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showVehicleType && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Vehicle Type
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="vehicleType"
                          value={vehicleType || ""}
                          placeholder="Search by Vehicle Type"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showPackageType && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Package Type
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="packageType"
                          value={packageType || ""}
                          placeholder="Search by Package Type"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* {showAdmin &&
                renderMultiSelectChips(
                  "Select Admin",
                  serviceApiUrl ?? "",
                  "reportScheduling",
                  reportSchDropdownData,
                  reportSchSelected,
                  setReportSchDropDownData,
                  setReportSchSelected
                )} */}
              {/* {isReportScheduling &&
                renderMultiSelectChips(
                  "Select Report Scheduling",
                  serviceApiUrl ?? "",
                  "reportScheduling",
                  reportSchDropdownData,
                  reportSchSelected,
                  setReportSchDropDownData,
                  setReportSchSelected
                )} */}
              {isReportType &&
                renderMultiSelectChips(
                  "Select Report Type",
                  serviceApiUrl ?? "",
                  "reportType",
                  reportTypeDropdownData,
                  reportTypeSelected,
                  setReportTypeDropDownData,
                  setReportTypeSelected
                )}
              {isReportCat &&
                renderMultiSelectChips(
                  "Select Report Category",
                  serviceApiUrl ?? "",
                  "reportCat",
                  reportCatDropdownData,
                  reportCatSelected,
                  setReportCatDropDownData,
                  setReportCatSelected
                )}
              {isReportDateType &&
                renderMultiSelectChips(
                  "Select Report Date Type",
                  "",
                  "reportDateType",
                  reportDateTypeDropdownData,
                  reportDateTypeSelected,
                  setReportDateTypeDropDownData,
                  setReportDateTypeSelected
                )}
              {isDTSUpdateDate && (
                <div>
                  <label className="form__label form__label--medium">
                    Select DTS Update Date Range
                  </label>
                  <div className="formCol">
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">From</label>
                          <input
                            type="date"
                            id="DTSDateFrom"
                            name="DTSDateFrom"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            max={dtsUpdateEndDate || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setDtsStartDate) {
                                setDtsStartDate(e.target.value);
                              }
                            }}
                            value={dtsUpdateStartDate}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">To</label>
                          <input
                            type="date"
                            id="DTSDateTo"
                            name="DTSDateTo"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            min={dtsUpdateStartDate || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setDtsEndDate) {
                                setDtsEndDate(e.target.value);
                              }
                            }}
                            value={dtsUpdateEndDate}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isCreatedOn && (
                <div>
                  <label className="form__label form__label--medium">
                    Created On
                  </label>
                  <div className="formCol">
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">From</label>
                          <input
                            type="date"
                            id="CreatedStartDate"
                            name="CreatedStartDate"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            max={createdEndDate || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setCreatedStartDate) {
                                setCreatedStartDate(e.target.value);
                              }
                            }}
                            value={createdStartDate}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">To</label>
                          <input
                            type="date"
                            id="CreatedEndDate"
                            name="CreatedEndDate"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            min={createdStartDate || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setCreatedEndDate) {
                                setCreatedEndDate(e.target.value);
                              }
                            }}
                            value={createdEndDate}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showServiceType &&
                renderMultiSelectChips(
                  "Select Service Type",
                  serviceApiUrl ?? "",
                  "serviceLevel",
                  serviceDropdownData,
                  serviceSelected,
                  setServiceDropdownData,
                  setServiceSelected
                )}
              {showOrderDate && (
                <div>
                  <label className="form__label form__label--medium">
                    Select Order Date Range
                  </label>
                  <div className="formCol">
                    <div className="formRow formRow__2">
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">From</label>
                          <input
                            type="date"
                            id="orderDateFrom"
                            name="orderDateFrom"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            max={orderDateTo || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setOrderDateFrom) {
                                setOrderDateFrom(e.target.value);
                              }
                            }}
                            value={orderDateFrom}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                      <div className="formCol">
                        <div className="form__Field">
                          <label className="form__label">To</label>
                          <input
                            type="date"
                            id="orderDateTo"
                            name="orderDateTo"
                            className="form__date form__date--sm"
                            placeholder="DD/MM/YYYY"
                            autoComplete="off"
                            min={orderDateFrom || undefined}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              if (setOrderDateTo) {
                                setOrderDateTo(e.target.value);
                              }
                            }}
                            value={orderDateTo}
                            onKeyDown={handleFilterKeyDown}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showPaymentStatus &&
                renderMultiSelectChips(
                  "Select Payment Status",
                  serviceApiUrl ?? "",
                  "paymentStatus",
                  paymentStatusDropdownData,
                  paymentStatusSelected,
                  setPaymentStatusDropdownData,
                  setPaymentStatusSelected
                )}
              {!isStatusHide && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="selectedStatus"
                        className="form__label form__label--medium"
                      >
                        Select Status
                      </label>
                      <select
                        id="selectedStatus"
                        className="form__select form__select--sm"
                        value={selectStatus?.id}
                        onChange={(e) => {
                          handleSelectFieldChange(e, "selectedStatus");
                        }}
                        onKeyDown={handleFilterKeyDown}
                        name="selectedStatus"
                      >
                        <option value="" data-name="">
                          -Select-
                        </option>
                        {customStatusOptions
                          ? customStatusOptions.map((opt) => (
                            <option key={opt.value} value={opt.value} data-name={opt.label}>
                              {opt.label}
                            </option>
                          ))
                          : (
                            <>
                              <option value="1" data-name="Active">
                                Active
                              </option>
                              <option value="0" data-name="Deactivate">
                                Inactive
                              </option>
                            </>
                          )}
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {showInvoiceSetting &&
                renderMultiSelectChips(
                  "Select Invoice Setting",
                  serviceApiUrl ?? "",
                  "invoiceSetting",
                  invoiceSettingDropdownData,
                  invoiceSettingSelected,
                  setInvoiceSettingDropdownData,
                  setInvoiceSettingSelected
                )}
              {showCity && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search City
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="city"
                          value={city || ""}
                          placeholder="Search by City"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showState && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                       Search State
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="state"
                          value={state || ""}
                          placeholder="Search by State"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showZipCode && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Zipcode
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="zipcode"
                          value={zipcode || ""}
                          placeholder="Search by Zipcode"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showStateDropdown && stateOptions && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="stateDropdown"
                        className="form__label form__label--medium"
                      >
                        State
                      </label>
                      <div className="formCol">
                        <select
                          id="stateDropdown"
                          className="form__input form__input--sm"
                          value={state || ""}
                          onChange={(e) => setState && setState(e.target.value)}
                          onKeyDown={handleFilterKeyDown}
                        >
                          <option value="">--Select--</option>
                          {stateOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showCountry && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="country"
                        className="form__label form__label--medium"
                      >
                        Country
                      </label>
                      <div className="formCol">
                        {countryOptions ? (
                          <select
                            id="country"
                            className="form__input form__input--sm"
                            value={country || ""}
                            onChange={(e) => setCountry && setCountry(e.target.value)}
                            onKeyDown={handleFilterKeyDown}
                          >
                            <option value="">--Select--</option>
                            {countryOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <SearchInput
                            type="text"
                            name="country"
                            value={country || ""}
                            placeholder="Search by Country"
                            onChange={handleKeywordChange}
                            onKeyDown={handleFilterKeyDown}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showAddress && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Address
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="address"
                          value={address || ""}
                          placeholder="Search by address"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showDescription && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Description
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="description"
                          value={description || ""}
                          placeholder="Search by Description"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showScac && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search SCAC
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="Scsc"
                          value={scac || ""}
                          placeholder="Search by SCAC"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showCarrier && (
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field">
                      <label
                        htmlFor="customerSelectedLevel"
                        className="form__label form__label--medium"
                      >
                        Search Carrier
                      </label>
                      <div className="formCol">
                        <SearchInput
                          type="text"
                          name="carrier"
                          value={carrier || ""}
                          placeholder="Search by Carrier"
                          onChange={handleKeywordChange}
                          onKeyDown={handleFilterKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isTicketRegion &&
                renderMultiSelectChips(
                  "Region",
                  "",
                  "ticketRegion",
                  ticketRegionDropdownData,
                  ticketRegionSelected,
                  setTicketRegionDropdownData,
                  setTicketRegionSelected
                )}
              {isTicketPriority &&
                renderMultiSelectChips(
                  "Priority",
                  "",
                  "ticketPriority",
                  ticketPriorityDropdownData,
                  ticketPrioritySelected,
                  setTicketPriorityDropdownData,
                  setTicketPrioritySelected
                )}
              {isTicketStatus &&
                renderMultiSelectChips(
                  "Status",
                  "",
                  "ticketStatus",
                  ticketStatusDropdownData,
                  ticketStatusSelected,
                  setTicketStatusDropdownData,
                  setTicketStatusSelected
                )}
              {isTicketGroup &&
                renderMultiSelectChips(
                  "Group",
                  "",
                  "ticketGroup",
                  ticketGroupDropdownData,
                  ticketGroupSelected,
                  setTicketGroupDropdownData,
                  setTicketGroupSelected
                )}
              {isTicketUserType &&
                renderMultiSelectChips(
                  "User Type",
                  "",
                  "ticketUserType",
                  ticketUserTypeDropdownData,
                  ticketUserTypeSelected,
                  setTicketUserTypeDropdownData,
                  setTicketUserTypeSelected
                )}
            </div>
            <div className="filter__dropdown__footer">
              <div className="btn__group">
                <button className="btn btn__white" onClick={handleClearFilter}>
                  Clear
                </button>
                <button
                  className="btn btn__primary"
                  onClick={handleApplyFilter}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSideMenu;
